import React from "react";
import { OrderState } from "../../pages/OrderDetailsPage/OrderDetailsTypes";
import { useStyles } from "./DeliveryStatusTag.styles";
import { DELIVERY_STATUS_UI } from "./deliveryStatus.ui";
import { useTranslation } from "react-i18next";

interface DeliveryStatusTagProps {
  state: OrderState;
  onClick?: () => void;
}

const DeliveryStatusTag: React.FC<DeliveryStatusTagProps> = ({
  state,
  onClick,
}) => {
  const { t } = useTranslation();
  const loweredCaseState = state?.toLowerCase() as OrderState;
  const classes = useStyles({ state: loweredCaseState });
  const config = DELIVERY_STATUS_UI[loweredCaseState];

  if (!config) return null;

  return (
    <span
      className={classes.root}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      {t(config.label)}
    </span>
  );
};

export default DeliveryStatusTag;
